var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCitizen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.765,
    height: 276.001,
    viewBox: "0 0 193.765 276.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#07a1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1a95d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3a82c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5b6fb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#6265c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6f53e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7d51d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a44ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d34b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#dc5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f06022"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "U-CITIZEN-5in_transp.svg",
    "data-name": "U-CITIZEN-5in transp.svg",
    transform: "translate(-48.62 -19.007)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 96.476,
    cy: 4.848,
    rx: 96.476,
    ry: 4.848,
    transform: "translate(49.434 285.313)",
    opacity: 0.504,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U_path",
    "data-name": "U path",
    d: "M144,289.833a97.555,97.555,0,0,1-35.951-6.777,93.278,93.278,0,0,1-29.557-18.6,87.332,87.332,0,0,1-20.132-27.882,82.826,82.826,0,0,1-7.447-34.317l-.064-3.58V62.613H76.16V198.572l.064,3.572c0,16.5,6.937,32.052,19.534,43.8a71.936,71.936,0,0,0,96.492,0c12.6-11.752,19.534-27.308,19.534-43.8v-.151l.04-3.389V62.613h25.307V198.756l-.04,3.46a82.855,82.855,0,0,1-7.447,34.356,87.3,87.3,0,0,1-20.132,27.882,93.418,93.418,0,0,1-29.557,18.6A97.555,97.555,0,0,1,144,289.833Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Citizen",
    d: "M13576.96-2795.406a13.632,13.632,0,0,1-4.758-3.332,14.628,14.628,0,0,1-3-5.042,18.77,18.77,0,0,1-1.043-6.329,16.844,16.844,0,0,1,1.2-6.4,14.954,14.954,0,0,1,3.342-5.031,14.959,14.959,0,0,1,5.135-3.284,17.936,17.936,0,0,1,6.592-1.174,16.816,16.816,0,0,1,3.3.314,16.559,16.559,0,0,1,2.894.853,14.27,14.27,0,0,1,2.479,1.3,11.65,11.65,0,0,1,2.01,1.675l-2.431,3.27a3.093,3.093,0,0,1-.56.542,1.462,1.462,0,0,1-.891.245,1.652,1.652,0,0,1-.726-.166c-.23-.114-.469-.255-.725-.414s-.535-.345-.846-.535a7.007,7.007,0,0,0-1.092-.535,8.921,8.921,0,0,0-1.478-.414,10.382,10.382,0,0,0-1.976-.166,9.041,9.041,0,0,0-3.587.694,7.737,7.737,0,0,0-2.783,1.986,9.319,9.319,0,0,0-1.82,3.125,12.433,12.433,0,0,0-.652,4.119,13,13,0,0,0,.652,4.251,9.338,9.338,0,0,0,1.771,3.125,7.515,7.515,0,0,0,2.614,1.93,7.876,7.876,0,0,0,3.208.663,15.8,15.8,0,0,0,1.792-.1,7.321,7.321,0,0,0,1.5-.335,7.532,7.532,0,0,0,1.326-.6,8.019,8.019,0,0,0,1.268-.936,2.245,2.245,0,0,1,.56-.349,1.479,1.479,0,0,1,.621-.135l-.024-.01a1.394,1.394,0,0,1,.508.1,1.4,1.4,0,0,1,.5.335l2.863,3a11.952,11.952,0,0,1-4.707,3.709,16.332,16.332,0,0,1-6.688,1.253A15.9,15.9,0,0,1,13576.96-2795.406Zm92.7.87v-2.776a2.883,2.883,0,0,1,.169-.974,3.345,3.345,0,0,1,.47-.884l14.647-20.922h-14.092v-5.549h23.267v2.6a3.406,3.406,0,0,1-.183,1.091,3.908,3.908,0,0,1-.5,1l-14.6,20.86h14.813v5.549Zm85.528-.017a3.5,3.5,0,0,1-1.412-.256,2.961,2.961,0,0,1-1.108-.939l-14.662-18.532c.042.546.08,1.071.1,1.6s.042,1,.042,1.46v16.671h-6.364v-31.095h3.806a7.182,7.182,0,0,1,.787.038h-.007a2.023,2.023,0,0,1,.573.162,2.044,2.044,0,0,1,.493.335,5.283,5.283,0,0,1,.535.573l14.776,18.681c-.06-.6-.1-1.181-.128-1.74s-.042-1.091-.042-1.592v-16.457h6.364v31.095Zm-52.655,0v-31.095h20.021v5.549h-12.766v7.255h9.775v5.335h-9.775v7.407h12.766v5.549Zm-49.307,0v-31.095h7.255v31.095Zm-24.724,0v-25.38h-8.753v-5.715h24.724v5.715h-8.754v25.38Zm-24.758,0v-31.095h7.258v31.095ZM13694.125-2825.641Zm0-.007v.007Z",
    transform: "translate(-13519.538 2845)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitizen);
export default __webpack_public_path__ + "static/media/citizen.b6b0d7c9eba2dce5eb7b0fed4d5cb09f.svg";
export { ForwardRef as ReactComponent };